var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._g({attrs:{"small":_vm.defaultSize,"x-small":_vm.small,"large":_vm.xLarge,"color":_vm.color,"size":_vm.size}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }